import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
var _class, _class2;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import PropTypes from 'prop-types';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import { createMessageGroups } from '../../../utils/conversationUtil';
import { Conversation, MessageGroup } from '../../components/Conversation';
import MessageScrollView from '../../components/MessageScrollView';
import MessageContainer from './MessageContainer';
import TypingIndicator from '../../components/TypingIndicator';
import DepartingMessageBubble from '../../components/Conversation/DepartingMessageBubble';

/**
 * Conversation container responsible for displaying
 * a flat list of messages in a.. less flat way.
 */
var ConversationContainer = observer(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
  function ConversationContainer() {
    _classCallCheck(this, ConversationContainer);
    return _callSuper(this, ConversationContainer, arguments);
  }
  _inherits(ConversationContainer, _React$Component);
  return _createClass(ConversationContainer, [{
    key: "messageGroups",
    get:
    /**
     * We have a flat stream of messages which we want to group
     * up and attach metadata to, so they can be displayed like a boss.
     */
    function get() {
      // We are expecting the messages to be in order.
      return createMessageGroups(this.props.messages, this.props.jobTaxAssistant);
    }
  }, {
    key: "renderMessageGroups",
    value: function renderMessageGroups(messageGroups) {
      var _this$props = this.props,
        onMarkAsRead = _this$props.onMarkAsRead,
        onDocumentClick = _this$props.onDocumentClick,
        onViewPrompt = _this$props.onViewPrompt,
        onViewRejectDraft = _this$props.onViewRejectDraft,
        onViewApproveDraft = _this$props.onViewApproveDraft,
        isReadOnly = _this$props.isReadOnly,
        me = _this$props.me,
        onDelete = _this$props.onDelete;
      return messageGroups.map(function (group, i) {
        return /*#__PURE__*/React.createElement("div", {
          key: i
        }, /*#__PURE__*/React.createElement(MessageGroup, {
          mine: group.sender === me
        }, group.messages.map(function (message) {
          // `message` is a plain mapped object, not the actual instance,
          // which is added as a property.
          var actualMessage = message.message;
          return /*#__PURE__*/React.createElement(MessageContainer, _extends({
            key: actualMessage.id,
            message: actualMessage,
            seenBy: message.seenBy.map(function (x) {
              return x.avatar || x.picture || x.avatarFallback;
            }),
            group: group,
            me: me,
            onDelete: onDelete,
            onDocumentClick: onDocumentClick && function () {
              return onDocumentClick(actualMessage);
            },
            onViewPrompt: onViewPrompt,
            onViewRejectDraft: onViewRejectDraft,
            onViewApproveDraft: onViewApproveDraft,
            isReadOnly: isReadOnly
          }, !actualMessage.isRead && {
            onEnterViewport: function onEnterViewport() {
              return onMarkAsRead(actualMessage);
            }
          }));
        })), group.hasSenderLeftConversation && /*#__PURE__*/React.createElement(DepartingMessageBubble, {
          displayName: group.sender.displayName
        }));
      });
    }
  }, {
    key: "renderTypingIndicator",
    value: function renderTypingIndicator() {
      var _this$props$jobTaxAss;
      // The names of the people currently typing.
      // NOTE: Only supported for job tax assistants as we don't have typing indication
      // on the server yet for regular users.
      var peopleCurrentlyTyping = (_this$props$jobTaxAss = this.props.jobTaxAssistant) !== null && _this$props$jobTaxAss !== void 0 && _this$props$jobTaxAss.isTyping ? [this.props.jobTaxAssistant.displayName] : [];
      return peopleCurrentlyTyping.length > 0 ? /*#__PURE__*/React.createElement(TypingIndicator, {
        peopleCurrentlyTyping: peopleCurrentlyTyping
      }) : null;
    }

    /**
     * Does the render thing.
     */
  }, {
    key: "render",
    value: function render() {
      var messageGroups = this.messageGroups;
      return /*#__PURE__*/React.createElement(MessageScrollView, {
        onLoadMore: this.props.onLoadMore,
        isLoadingMore: this.props.isLoadingMore,
        messageCount: this.props.messages.length,
        scrollToBottom: unreadMessagesFormatter({
          count: this.props.unreadMessagesCount
        }),
        scopeChangeRequests: this.props.scopeChangeRequests,
        showScopeChangeRequestResponseDialog: this.props.showScopeChangeRequestResponseDialog,
        typingIndicator: this.renderTypingIndicator()
      }, this.props.children, /*#__PURE__*/React.createElement(Conversation, null, messageGroups.length === 0 ? this.props.noMessages || false : this.renderMessageGroups(messageGroups)), this.props.footer && this.props.footer);
    }
  }]);
}(React.Component), _applyDecoratedDescriptor(_class2.prototype, "messageGroups", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "messageGroups"), _class2.prototype), _class2)) || _class;
ConversationContainer.propTypes = {
  messages: PropTypes.any,
  scopeChangeRequests: PropTypes.array,
  showScopeChangeRequestResponseDialog: PropTypes.func,
  me: PropTypes.any,
  onMarkAsRead: PropTypes.func,
  onLoadMore: PropTypes.func,
  isLoadingMore: PropTypes.bool,
  noMessages: PropTypes.element,
  unreadMessagesCount: PropTypes.number,
  otherName: PropTypes.string,
  onDocumentClick: PropTypes.any,
  jobTaxAssistant: PropTypes.object
};
export default ConversationContainer;

/**
 * Simple message formatter.
 */
function unreadMessagesFormatter(_ref) {
  var count = _ref.count;
  if (!count) {
    return 'Scroll to bottom';
  }
  if (count === 1) {
    return '1 unread message';
  }
  return "".concat(count, " unread messages");
}
//# sourceMappingURL=index.js.map
